<template>
  <footer>©杭电助手 All Rights Reserved.</footer>
</template>
<script>
export default {
  name: 'Foot'
}
</script>
<style scoped>
footer {
  padding-bottom: 100px;
}
</style>
